import * as React from "react";
import {Route} from 'react-router-dom';
import {CompaniesChallenge} from "./companies/CompanyChallenge";
import {AddActivationCodes} from './activation-codes/AddActivationCodes';

export default [
    <Route exact path="/companies-challenge" component={CompaniesChallenge}/>,
    <Route exact path="/add-activation-codes" component={AddActivationCodes}/>,
];
